import { render, staticRenderFns } from "./EditPeriodActionPlanDinamic.vue?vue&type=template&id=548244d5&"
import script from "./EditPeriodActionPlanDinamic.js?vue&type=script&lang=js&"
export * from "./EditPeriodActionPlanDinamic.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports